import React from 'react';
import { Box } from '@tonic-ui/react';
import { useThemeColorStyle } from '../../hooks/use-theme-color-style';
import OverlayLoader from './overlay-loader';

const GlobalLoader = ({ isLoading }) => {
  const colorStyle = useThemeColorStyle();
  return (
    <OverlayLoader
      isLoading={isLoading}
      top="40px"
      zIndex="1000" //higher z-index to overlap loader on other web apps loader
      backgroundColor={colorStyle.background.secondary} //background value based on colorMode in redux because header default theme is dark
    />
  );
};

GlobalLoader.displayName = 'GlobalLoader';
export default GlobalLoader;
